export default __webpack_public_path__ + "static/media/gallery3.751f0920.png";